import React from 'react';

import { StyledTabs } from './styles';
import type { TabsProps } from './types';

export default function Tabs({ ...props }: TabsProps) {
  return <StyledTabs {...props} />;
}
